<template>
  <div class="contact-modal">
    <div class="modal-header">
      <span>重新上传申报表</span>
      <i class="close" @click="cancel"></i>
    </div>
    <div class="modal-content">
      <div class="form-item upload-item">
        <div class="upload-wrap">
          <div class="upload-add" :class="loading ? 'loading' : ''">
            上传申报表
            <input v-if="!loading" type="file"  @change="onFileChange">
            <!-- accept="image/*" -->
          </div>
          <div class="error-tip" v-if="form.scanningCopyFileList.error">{{form.scanningCopyFileList.error}}</div>
          <div class="upload-file-wrap">
            <div class="upload-file"
                  v-for="(item, index) in form.scanningCopyFileList.value"
                  :key="index">
              <!-- <img :src="item.url" alt=""> -->
              <!-- <span>{{item.name}}</span> -->
              <a :href="item.url" target="_blank"> {{ item.name }}</a>
              <i class="upload-file-delete" @click="deleteFile(index)"></i>
            </div>
          </div>
        </div>
      </div>
      <hr>
      <div class="notice-tip">
        <img src="../../../assets/images/icon-tip.png" alt="" class="icon-notice" />
        <div>新上传申报表将覆盖原上传申报表</div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="cancel" @click="cancel">取消</button>
      <button class="confirm" @click="confirm">确定</button>
    </div>
  </div>
</template>

<script>
import { uuid } from "@/service/util";
import upload from '@/service/upload';
export default {
  data() {
    return {
      form: {        
        scanningCopyFileList: {
          value: [],
          error: false,
          validate: v => {
            if (!v.length) {
              this.form.scanningCopyFileList.error = '请上传图片至少1张';
              return false;
            }
            this.form.scanningCopyFileList.error = null;
            return true;
          }
        },
      },
      loading: false
    }
  },
  methods: {
    onFileChange($event) {
			const file = $event.target.files[0];
			if (this.loading) return false;
			this.loading = true;
			upload(file).then(url => {
				this.form.scanningCopyFileList.value.push({
          // fileBizType: "cover",
          // type: "image/png",
          uid: uuid(),
					name: file.name,
					url
				})
			}).finally(() => {
				this.loading = false;
			})
		},
		deleteFile(idx) {
			this.form.scanningCopyFileList.value.splice(idx, 1);
		},
    cancel() {
      this.$emit('cancel');
    },
    confirm() {     
      
      
      this.$emit('confirm', this.form.scanningCopyFileList.value);
    }
  }
}
</script>

<style lang="less" scoped>
.contact-modal {
  width: 640px;
  background: #FFFFFF;
  padding: 30px 0;
  box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.0600);

  .modal-header {
    font-size: 20px;
    font-family: PingFang-SC-Bold, PingFang-SC;
    font-weight: bold;
    color: #333333;
    text-align: center;
    margin-bottom: 40px;
    position: relative;

    i {
      cursor: pointer;
      width: 20px;
      height: 20px;
      background: url(../../../assets/images/icon-close.png) no-repeat center center;
      background-size: 100% 100%;
      position: absolute;
      right: 20px;
      top: 0;
    }
  }

  .modal-content {
    margin-bottom: 20px;

    .form-item {
      padding: 0 40px 0 56px;
      margin-bottom: 24px;
      display: flex;
      align-items: center;

      &-label {
        width: 80px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #262626;
        margin-right: 20px;
      }

      &-value {
        flex: 1;
        height: 46px;
        background: #F5F5F5;
        position: relative;

        .error-tip {
          position: absolute;
          left: 0;
          top: 100%;
          font-size: 12px;
          color: #FF3B2F;
          line-height: 20px;
          display: none;
        }

        &.error {
          border: 1px solid #FF3B2F;

          .error-tip {
            display: block;
          }
        }

        input {
          width: 80%;
          height: 100%;
          padding: 0 16px;
        }                
      }

      .upload-wrap {

        .error-tip {
          font-size: 12px;
          color: #FF3B2F;
          line-height: 20px;
        }

        .upload-file-wrap {
          display: flex;
          flex-wrap: wrap;
          padding-top: 20px;
          
          .upload-file {
            padding: 10px;
            color: #06AE63;
            border-radius: 5px;
            margin-right: 20px;
            margin-bottom: 10px;
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;

            > img {
              width: 50px;
              height: 50px;
              display: block;
              margin-bottom: 5px;
            }

            span {
              width: 80px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            
            &:hover {
              .upload-file-delete {
                display: block;
              }
            }
            
            &-delete {
              display: none;
              cursor: pointer;
              width: 15px;
              height: 15px;
              position: absolute;
              right: -4px;
              top: -4px;
              background: #FF3B2F url(../../../assets/images/icon-close.png) no-repeat center center;
              background-size: 6px 6px;
              border-radius: 50%;
            }
          }
        }

        .upload-add {
          padding: 10px;
          color: #ffffff;
          border-radius: 5px;
          width: 120px;
          padding-left: 30px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          background: #06AE63 url(../../../assets/images/icon-upload.png) no-repeat 5px center;
          background-size: 20px 20px;
          position: relative;
          
          &.loading {
            background-image: url(../../../assets/images/icon-loading.gif);
            background-position: center center;
          }
          
          > input {
            position: absolute;
            cursor: pointer;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            opacity: 0;
          }
        }
      }

    }

    hr {
      height: 1px;
      background: #EEEEEE;
      margin: 16px 0 20px 0;
    }

    .notice-tip {
      padding: 0 40px 0 56px;
      display: flex;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #787878;
      line-height: 24px;

      .icon-notice {
        width: 16px;
        height: 16px;
        display: block;
        margin-top: 4px;
        margin-right: 8px;
      }
    }
  }

  .modal-footer {
    display: flex;
    align-items: center;
    justify-content: center;

    button {
      width: 120px;
      height: 40px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      outline: none;
      border: none;
      cursor: pointer;

      &.cancel {
        margin-right: 20px;
        color: #06AE63;
        background: rgba(6,174,99,0.1000);
      }

      &.confirm {
        background: #06AE63;
        color: #FFFFFF;
      }
    }
  }
}
</style>